// src/features/editor/components/studio/blockTypeLabels.ts
import {
  CheckSquare,
  CircleDot,
  FileText,
  Image as ImageIcon,
  Layers,
  Link2,
  Lock,
  PenLine,
  Play,
  ToggleLeft,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import type { Block } from '@/types/blocks'
import { messagesNow } from '@/i18n'
import { messages } from './messages'

export const typeLabel = (block: Block): string => {
  const m = messagesNow(messages)
  switch (block.type) {
    case 'info':
      return m.typeLabelInfo
    case 'quiz':
      if (block.quizType === 'yes_no') return m.typeLabelYesNo
      if (block.quizType === 'fill_blank') return m.typeLabelFillBlank
      return block.multiAnswer ? m.typeLabelQuizMulti : m.typeLabelQuizSingle
    case 'match':
      return m.typeLabelMatch
    case 'article':
      return m.typeLabelArticle
    case 'video':
      return m.typeLabelVideo
    case 'design':
      return m.typeLabelDesign
    default:
      return m.typeLabelUnknown
  }
}

export const typeIcon = (block: Block): LucideIcon => {
  switch (block.type) {
    case 'info':
      return ImageIcon
    case 'quiz':
      // Те же значки, что у карточек окна «Добавить блок» (`blockTypeMatrix`).
      if (block.quizType === 'yes_no') return ToggleLeft
      if (block.quizType === 'fill_blank') return PenLine
      return block.multiAnswer ? CheckSquare : CircleDot
    case 'match':
      return Link2
    case 'video':
      return Play
    case 'article':
      return FileText
    case 'design':
      return Layers
    default:
      return Lock
  }
}

/** Header meta (title-case label + description + chip-color id) for the block panel — ref parity. */
export const typeMeta = (block: Block): { label: string; description: string; chipId: string } => {
  const m = messagesNow(messages)
  switch (block.type) {
    case 'info':
      return { label: m.metaInfo, description: m.metaInfoDesc, chipId: 'image' }
    case 'quiz':
      // `chipId` — id карточки окна «Добавить блок»: цвет миниатюры совпадает с ней.
      if (block.quizType === 'yes_no')
        return { label: m.metaYesNo, description: m.metaYesNoDesc, chipId: 'yes_no' }
      if (block.quizType === 'fill_blank')
        return { label: m.metaFillBlank, description: m.metaFillBlankDesc, chipId: 'fill_blank' }
      return block.multiAnswer
        ? { label: m.metaQuizMulti, description: m.metaQuizMultiDesc, chipId: 'quiz-multi' }
        : { label: m.metaQuizSingle, description: m.metaQuizSingleDesc, chipId: 'quiz-single' }
    case 'match':
      return { label: m.metaMatch, description: m.metaMatchDesc, chipId: 'match' }
    case 'video':
      return { label: m.metaVideo, description: m.metaVideoDesc, chipId: 'video' }
    case 'article':
      return { label: m.metaArticle, description: m.metaArticleDesc, chipId: 'article' }
    case 'design':
      return { label: m.metaDesign, description: m.metaDesignDesc, chipId: 'design' }
    default:
      return { label: m.metaUnknown, description: '', chipId: 'unknown' }
  }
}
